<template>
  <div class="card overview-card h-100">
    <div class="card-body p-3">
      <h6 class="mb-0 overview-card-title">{{ title }}</h6>
      <p v-if="subtitle" class="text-xs text-secondary mb-0 mt-1">{{ subtitle }}</p>
      <div class="mt-3">
        <div v-if="error" class="text-sm text-secondary">{{ $t("key_dashboard_load_error") }}</div>
        <div v-else-if="loading && empty" class="d-flex justify-content-center py-4">
          <div class="spinner-border spinner-border-sm text-secondary" role="status"></div>
        </div>
        <div v-else-if="empty" class="text-sm text-secondary">{{ $t("key_dashboard_no_data") }}</div>
        <slot v-else />
      </div>
    </div>
  </div>
</template>

<script>
// Frame of every dashboard block: title, and the error, loading and empty
// states, so each block only draws its data.
export default {
  name: "OverviewCard",
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: "" },
    loading: { type: Boolean, default: false },
    error: { type: [Object, Error, String], default: null },
    empty: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.overview-card {
  border-radius: 0.75rem;
  box-shadow: 0 1px 3px rgba(16, 24, 40, 0.06);
}

.overview-card-title {
  font-weight: 600;
}
</style>
